let payment_form = require( './payment-form' );

let payment_form_switcher = ( function( $ ) {

	let $switcher;

	let _init = function() {
		$switcher = $( '#payment-form-switcher' );

		if ( $switcher.length > 0 ) {
			$switcher.find( 'a.button' ).on( 'click', _switch_form )
		}
	};

	let _switch_form = function( e ) {
		e.preventDefault();

		let $el = $( this );

		if ( $el.hasClass( 'active' ) ) {
			return; // We're already on this form, no need to do anything
		}

		let new_form_id = $el.data( 'form' ) + '-payment-form-wrap ';

		$switcher.find( 'a.button' ).removeClass( 'active' );
		$el.addClass( 'active' );

		let $forms = $( '#payment-forms' );

		$forms.find( '.payment-form-wrap' ).removeClass( 'active' );
		$forms.find( '#' + new_form_id ).addClass( 'active' );

		payment_form.on_form_switch( new_form_id.trim() == 'online-payment-form-wrap' ? 1 : 2 );
	};

	$( document ).ready( _init );

	return {};

} )( jQuery );

module.exports = payment_form_switcher;